// extracted by mini-css-extract-plugin
export default {"form_drawer":"ConfirmWithOptionsDialog_form_drawer__RfPK6"};